export const DownSolidLineRightColorIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="121" height="14" viewBox="0 0 121 14" fill="none">
            <g clipPath="url(#clip0_2081_481)">
                <path d="M0.97583 0.965576L17.9841 13.0345L34.9876 0.965576L51.9959 13.0345L68.9993 0.965576L86.0076 13.0345L103.016 0.965576L120.024 13.0345" stroke="#F26522" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2081_481">
                    <rect width="121" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}